import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchWorkflowListRequest = createAction("workflowList/fetchWorkflowListRequest");

const initialState = {
  workflows: [],
  loading: false,
  error: null,
  lastUpdated: null
};

const workflowListSlice = createSlice({
  name: "workflowList",
  initialState,
  reducers: {
    fetchWorkflowListStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWorkflowListSuccess(state, action) {
      state.loading = false;
      state.workflows = action.payload || [];
      state.error = null;
      state.lastUpdated = Date.now();
    },
    fetchWorkflowListFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchWorkflowListStart,
  fetchWorkflowListSuccess,
  fetchWorkflowListFailure
} = workflowListSlice.actions;

export default workflowListSlice.reducer;
